module.exports = function(params) {
  var google_analytics_id = process.env.fluid_analytics_default,
    consoleCSS = 'background: #000; color: #bada55; padding: 2px;',
    showAnalytics = params.workflow !== 'prod';

  // If we are in production and a non-Fluid Env then use the
  // production GA account
  if ( params.workflow === 'prod' && !params.isFluidEnv ) {
    google_analytics_id = process.env.fluid_analytics_prod;
  }

  if (typeof window.ga === 'undefined') {
    (function(i,s,o,g,r,a,m) {
      i.GoogleAnalyticsObject=r;
      i[r]=i[r]||function() {
        (i[r].q=i[r].q||[]).push(arguments);
      },i[r].l=1*new Date();
      a=s.createElement(o),
      m=s.getElementsByTagName(o)[0];
      a.async=1;
      a.src=g;
      m.parentNode.insertBefore(a,m);
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
  }

  function FluidTimings(configureVersion, product) {
    this.data = {};
    this.configureVersion = configureVersion;
    this.product = product;
  }

  FluidTimings.prototype.timingKey = function(timingVariable) {
    return this.configureVersion + '-' + timingVariable + '-' + this.product;
  };

  FluidTimings.prototype.start = function(timingVariable) {
    if (showAnalytics) {
      console.log('%cFluid Analytics - Starting timing for ' + timingVariable + ' for product ' + this.product, consoleCSS);
    }
    this.data[this.timingKey(timingVariable)] = new Date();
  };

  FluidTimings.prototype.finish = function(timingVariable) {
    var endTime = new Date(),
      startTime = this.data[this.timingKey(timingVariable)];

    if(typeof startTime === 'undefined') {
      if (showAnalytics) {
        console.log('%cFluid Analytics - Missing start time for' + timingVariable, consoleCSS);
      }
      return;
    }

    var duration = endTime - startTime;

    if(duration <= 120000) {
      ga('Fluid.send', 'timing', this.configureVersion, timingVariable, duration, this.product.toString());
    }

    if (showAnalytics) {
      console.log('%cFluid Analytics - Duration of ' + timingVariable + ' for product ' + this.product + ' : ' + duration + 'ms', consoleCSS);
    }
  };

  window.fluidTimings = new FluidTimings('configure3.0', params.product);
  fluidTimings.start('initialize');

  ga('create', google_analytics_id, 'auto', {'name' : 'Fluid'});

  ga('Fluid.require', 'ec');
  ga('Fluid.send', 'pageview');
};
